import { Component, OnInit } from "@angular/core";
import { ConcessionaireService } from "../concessionaire.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { RoutingConstants } from "../../constants/routingConstants";
import { TokenService } from "src/app/core/services/token.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { CommonService } from "src/app/core/services/common.service";
import { MaintenanceUserService } from "src/app/core/services/maintenance-user.service";
import { AppConstants } from "src/app/constants/app.constants";

@Component({
  selector: "app-create-edit-concessionaire",
  templateUrl: "./create-edit-concessionaire.component.html",
  styleUrls: ["./create-edit-concessionaire.component.css"],
})
export class CreateEditConcessionaireComponent implements OnInit {
  public concessionaire;
  public operation: string;
  roles = AppConstants.roles;
  regionsList = AppConstants.regionsOfConcessionarie;
  public routing = RoutingConstants.concessionaireRouting;
  routingRoot: string = "";
  coId: string;

  sectionHidden = {
    datos: false,
    responsableGroup: false,
    responsable1: false,
    responsable2: false,
    responsable3: false,
    responsable4: false,
  };

  constructor(
    private concessionaireService: ConcessionaireService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private tokenService: TokenService,
    private toastrAlertService: ToastrAlertService,
    private commonService: CommonService,
    private maintenanceUserService: MaintenanceUserService
  ) {}

  ngOnInit(): void {
    this.initFormGroup();
    this.operation = this.activatedRoute.data["_value"]["operation"];
    if (
      this.operation === "edicion" &&
      this.activatedRoute.snapshot.params.id
    ) {
      let id = this.activatedRoute.snapshot.params.id;
      this.getConcessionaire(id);
    } else if (
      this.operation === "edicion" &&
      this.activatedRoute.data["_value"]["routing"]
    ) {
      this.getUserInfo();
    }
  }

  getConcessionaire(id: string) {
    this.concessionaireService.getConcessionaire(id).subscribe(
      (data) => {
        if (data != null) {
          this.setValues(data);
          this.coId = data.coId;
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getUserInfo() {
    this.routingRoot = this.activatedRoute.data["_value"]["routing"];
    this.maintenanceUserService
      .getUsuario("?_identificador=" + this.tokenService.getUserName())
      .subscribe(
        (data) => {
          if (data && data["usConcesionario"]) {
            this.getConcessionaire(data["usConcesionario"]);
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  public hasRole(): boolean {
    return (
      this.tokenService.hasRole(this.roles.CONCES) ||
      this.tokenService.hasRole(this.roles.ANALISTA) ||
      this.tokenService.hasRole(this.roles.ABASICO)
    );
  }

  initFormGroup() {
    if (this.tokenService.hasRole(this.roles.CONCES)) {
      this.concessionaire = new FormGroup({
        coId: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(8),
        ]),
        coApellidos1: new FormControl(
          { value: "", disabled: true },
          Validators.maxLength(32)
        ),
        coApellidos2: new FormControl(
          { value: "", disabled: true },
          Validators.maxLength(32)
        ),
        coApellidos3: new FormControl(
          { value: "", disabled: true },
          Validators.maxLength(32)
        ),
        coApellidos4: new FormControl(
          { value: "", disabled: true },
          Validators.maxLength(32)
        ),
        coCodigoFacturacion: new FormControl({ value: "", disabled: true }),
        coCorrelativo: new FormControl({ value: "1", disabled: true }),
        coDireccionEnvio: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(64),
        ]),
        coDireccionFacturacion: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(64),
        ]),
        coEmail1: new FormControl({ value: null, disabled: true }, [
          Validators.maxLength(128),
        ]),
        coEmail2: new FormControl({ value: null, disabled: true }, [
          Validators.maxLength(128),
        ]),
        coEmail3: new FormControl({ value: null, disabled: true }, [
          Validators.maxLength(128),
        ]),
        coEmail4: new FormControl({ value: null, disabled: true }, [
          Validators.maxLength(128),
        ]),
        coFax: new FormControl(
          { value: "", disabled: true },
          Validators.maxLength(16)
        ),
        coInicializado: new FormControl({ value: "0", disabled: true }),
        coLocalidadEnvio: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coLocalidadFacturacion: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coNombre: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(64),
        ]),
        coNombre1: new FormControl(
          { value: "", disabled: true },
          Validators.maxLength(64)
        ),
        coNombre2: new FormControl(
          { value: "", disabled: true },
          Validators.maxLength(64)
        ),
        coNombre3: new FormControl(
          { value: "", disabled: true },
          Validators.maxLength(64)
        ),
        coNombre4: new FormControl(
          { value: "", disabled: true },
          Validators.maxLength(64)
        ),
        coPaisEnvio: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coPaisFacturacion: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coProvinciaEnvio: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coProvinciaFacturacion: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coRegion: new FormControl(
          { value: "", disabled: true },
          Validators.required
        ),
        coResponsable: new FormControl({
          value: this.tokenService.getUserName(),
          disabled: true,
        }),
        coTelefono1: new FormControl({ value: "", disabled: true }, [
          Validators.maxLength(16),
        ]),
        coTelefono2: new FormControl({ value: "", disabled: true }, [
          Validators.maxLength(16),
        ]),
        coTelefono3: new FormControl({ value: "", disabled: true }, [
          Validators.maxLength(16),
        ]),
        coTelefono4: new FormControl({ value: "", disabled: true }, [
          Validators.maxLength(16),
        ]),
        coYear: new FormControl({
          value: new Date().getFullYear(),
          disabled: true,
        }),
        coZipEnvio: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(16),
        ]),
        coZipFacturacion: new FormControl({ value: "", disabled: true }, [
          Validators.required,
          Validators.maxLength(16),
        ]),
        coActivo: new FormControl({ value: true, disabled: true }),
      });
    } else {
      this.concessionaire = new FormGroup({
        coId: new FormControl("", [
          Validators.required,
          Validators.maxLength(8),
        ]),
        coApellidos1: new FormControl("", Validators.maxLength(32)),
        coApellidos2: new FormControl("", Validators.maxLength(32)),
        coApellidos3: new FormControl("", Validators.maxLength(32)),
        coApellidos4: new FormControl("", Validators.maxLength(32)),
        coCodigoFacturacion: new FormControl(""),
        coCorrelativo: new FormControl("1"),
        coDireccionEnvio: new FormControl("", [
          Validators.required,
          Validators.maxLength(64),
        ]),
        coDireccionFacturacion: new FormControl("", [
          Validators.required,
          Validators.maxLength(64),
        ]),
        coEmail1: new FormControl(null, [Validators.maxLength(128)]),
        coEmail2: new FormControl(null, [Validators.maxLength(128)]),
        coEmail3: new FormControl(null, [Validators.maxLength(128)]),
        coEmail4: new FormControl(null, [Validators.maxLength(128)]),
        coFax: new FormControl("", Validators.maxLength(16)),
        coInicializado: new FormControl("0"),
        coLocalidadEnvio: new FormControl("", [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coLocalidadFacturacion: new FormControl("", [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coNombre: new FormControl("", [
          Validators.required,
          Validators.maxLength(64),
        ]),
        coNombre1: new FormControl("", Validators.maxLength(64)),
        coNombre2: new FormControl("", Validators.maxLength(64)),
        coNombre3: new FormControl("", Validators.maxLength(64)),
        coNombre4: new FormControl("", Validators.maxLength(64)),
        coPaisEnvio: new FormControl("", [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coPaisFacturacion: new FormControl("", [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coProvinciaEnvio: new FormControl("", [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coProvinciaFacturacion: new FormControl("", [
          Validators.required,
          Validators.maxLength(32),
        ]),
        coRegion: new FormControl("", Validators.required),
        coResponsable: new FormControl(this.tokenService.getUserName()),
        coTelefono1: new FormControl("", [Validators.maxLength(16)]),
        coTelefono2: new FormControl("", [Validators.maxLength(16)]),
        coTelefono3: new FormControl("", [Validators.maxLength(16)]),
        coTelefono4: new FormControl("", [Validators.maxLength(16)]),
        coYear: new FormControl(new Date().getFullYear()),
        coZipEnvio: new FormControl("", [
          Validators.required,
          Validators.maxLength(16),
        ]),
        coZipFacturacion: new FormControl("", [
          Validators.required,
          Validators.maxLength(16),
        ]),
        coActivo: new FormControl(true),
      });
    }
  }

  setValues(data) {
    this.concessionaire.patchValue({
      coId: data.coId,
      coApellidos1: data.coApellidos1,
      coApellidos2: data.coApellidos2,
      coApellidos3: data.coApellidos3,
      coApellidos4: data.coApellidos4,
      coCodigoFacturacion: data.coCodigoFacturacion,
      coCorrelativo: data.coCorrelativo,
      coDireccionEnvio: data.coDireccionEnvio,
      coDireccionFacturacion: data.coDireccionFacturacion,
      coEmail1: data.coEmail1,
      coEmail2: data.coEmail2,
      coEmail3: data.coEmail3,
      coEmail4: data.coEmail4,
      coFax: data.coFax,
      coInicializado: data.coInicializado,
      coLocalidadEnvio: data.coLocalidadEnvio,
      coLocalidadFacturacion: data.coLocalidadFacturacion,
      coNombre: data.coNombre,
      coNombre1: data.coNombre1,
      coNombre2: data.coNombre2,
      coNombre3: data.coNombre3,
      coNombre4: data.coNombre4,
      coPaisEnvio: data.coPaisEnvio,
      coPaisFacturacion: data.coPaisFacturacion,
      coProvinciaEnvio: data.coProvinciaEnvio,
      coProvinciaFacturacion: data.coProvinciaFacturacion,
      coRegion: data.coRegion,
      coResponsable: this.tokenService.getUserName(),
      coTelefono1: data.coTelefono1,
      coTelefono2: data.coTelefono2,
      coTelefono3: data.coTelefono3,
      coTelefono4: data.coTelefono4,
      coYear: data.coYear,
      coZipEnvio: data.coZipEnvio,
      coZipFacturacion: data.coZipFacturacion,
      coActivo: data.coActivo == "Y" ? true : false,
    });
  }

  onUpdate() {
    this.concessionaireService
      .updateConcessionaire(this.concessionaire.value, this.coId)
      .subscribe(
        (data) => {
          if (this.routingRoot == "") {
            this.toastrAlertService.toastrSuccess(
              data["mensaje"],
              this.routing.list
            );
          } else {
            this.toastrAlertService.toastrSuccess(data["mensaje"]);
            this.tokenService.redirectPredefinedMailBox();
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  onCreate() {
    this.concessionaireService
      .createConcessionaire(this.concessionaire.value)
      .subscribe(
        (data) => {
          if (this.routingRoot == "") {
            this.toastrAlertService.toastrSuccess(
              data["mensaje"],
              this.routing.list
            );
          } else {
            this.toastrAlertService.toastrSuccess(data["mensaje"]);
            this.tokenService.redirectPredefinedMailBox();
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.concessionaire.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      this.concessionaire.value.coActivo = this.concessionaire.value.coActivo
        ? "Y"
        : "N";
      if (this.operation === "edicion") {
        this.onUpdate();
      } else if (this.operation === "creacion") {
        this.onCreate();
      }
    }
  }

  changeAddress(e) {
    if (e.target.value == "yes") {
      this.concessionaire.patchValue({
        coDireccionFacturacion: this.concessionaire.value.coDireccionEnvio,
        coLocalidadFacturacion: this.concessionaire.value.coLocalidadEnvio,
        coProvinciaFacturacion: this.concessionaire.value.coProvinciaEnvio,
        coPaisFacturacion: this.concessionaire.value.coPaisEnvio,
        coZipFacturacion: this.concessionaire.value.coZipEnvio,
      });
    } else if (e.target.value == "no") {
      this.concessionaire.patchValue({
        coDireccionFacturacion: "",
        coLocalidadFacturacion: "",
        coProvinciaFacturacion: "",
        coPaisFacturacion: "",
        coZipFacturacion: "",
      });
    }
  }

  goList() {
    if (this.routingRoot == "") {
      this.router.navigate([this.routing.list]);
    } else {
      this.tokenService.redirectPredefinedMailBox();
    }
  }
}
